import apiClient from './apiClient';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface RegisterData {
  username: string;
  password: string;
  email: string;
}

export interface User {
  id: number;
  username: string;
  email: string;
  avatar?: string;
  isAdmin: boolean;
}

export const login = async (credentials: LoginCredentials): Promise<User> => {
  const response = await apiClient.post('/auth/login', credentials);
  const { accessToken, user } = response.data;
  localStorage.setItem('token', accessToken);
  return user;
};

export const register = async (data: RegisterData): Promise<User> => {
  const response = await apiClient.post('/auth/register', data);
  const { accessToken, user } = response.data;
  localStorage.setItem('token', accessToken);
  return user;
};

export const getCurrentUser = async (): Promise<User | null> => {
  try {
    const response = await apiClient.get('/auth/me');
    return response.data;
  } catch {
    localStorage.removeItem('token');
    return null;
  }
};

export const logout = async (): Promise<void> => {
  const token = localStorage.getItem('token');
  if (token) {
    try {
      await apiClient.post('/auth/logout', { token });
    } catch {
      // Ignore errors on logout
    }
  }
  localStorage.removeItem('token');
};

/**
 * Check if the user is currently authenticated
 */
export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('token');
};

/**
 * Ensure user is authenticated before making API calls
 * This function can be used to wrap API calls that require authentication
 */
export const ensureAuthenticated = async (): Promise<User | null> => {
  if (!isAuthenticated()) {
    // Redirect to login page or handle unauthenticated state
    return null;
  }

  try {
    const currentUser = await getCurrentUser();
    if (!currentUser) {
      // Token might be invalid or expired
      logout();
      return null;
    }
    return currentUser;
  } catch {
    // Token validation failed
    logout();
    return null;
  }
};
